import React from 'react';
import HeaderLayoutBase from './HeaderLayoutBase'; // Import the new base component

// Wrapper for Right Aligned Header layout
const RightAlignedHeaderLayout = (props) => {
  // Pass all props down and set the specific alignment
  return <HeaderLayoutBase {...props} headerAlignment="right" />;
};

export default RightAlignedHeaderLayout; 